import Vue from 'vue';
import Vuetify from 'vuetify';

import 'vuetify/dist/vuetify.min.css';
import en from 'vuetify/es5/locale/en';
import es from 'vuetify/es5/locale/es';

Vue.use(Vuetify);

function getStylePreference(base = 'light', paramKey = 'dashboard_style') {
    let dark = base === 'dark';
    try {
        return localStorage.getItem(paramKey) === 'dark'
    } catch (e) {
        return dark;
    }
}

export default new Vuetify({
    lang: {
        locales: { en, es },
        current: 'en',
    },
    theme: {
        dark: getStylePreference(),
        options: { customProperties: true },
        themes: {
            dark: {
                background: '#000000',
                'ddblack': '#000000',
                'dddark': '#181818',
                'ddlightdark': '#282828',
                'ddlightgrey': '#afafaf',
                'ddgrey': '#838383',
                'ddwhite': '#ffffff',
                'ddblue': '#32B6D3',
                'dddarkblue': '#1D7387',
                'ddlightblue': '#39B6FF',
                'ddgreen': '#78CFE2',
                'ddlightgreen': '#BEFDFF',
                'ddorange': '#5CF7FF'
            },
            light: {
                background: '#fff',
                primary: '#32B6D3',
                success: '#32B6D3',
                'ddblack': '#fff',
                'dddark': '#eee',
                'ddlightdark': '#ddd',
                'ddgrey': '#838383',
                'ddlightgrey': '#afafaf',
                'ddwhite': '#333',
                'ddblue': '#32B6D3',
                'dddarkblue': '#1D7387',
                'ddlightblue': '#39B6FF',
                'ddgreen': '#78CFE2',
                'ddlightgreen': '#BEFDFF',
                'ddorange': '#5CF7FF'
            }
        }
    }
});
